/*
 * @Author: 小周
 * @Date: 2024-07-29 09:53:08
 * @LastEditTime: 2024-07-29 16:53:56
 * @LastEditors: MrZHLF
 * @Description: 评论点赞
 */
import { useState } from 'react'
import { operationType, cancelType } from '@/api/comment'
import { Toast } from 'react-vant'
import { isLogin } from '@/oauth/index'
const useCommentFabulousType = (likeItem) => {
  const [likesFlag, setLikesFlag] = useState(likeItem.likesFlag)
  const [likesNum, setLikesNum] = useState(likeItem.likesNum)
  const handleCommentLike = async (item) => {
    const { isStatus } = await isLogin()
    if (!isStatus) {
      Toast.fail('请先登录')
      return
    }
    let params = {
      objectId: item.commentId,
      operationType: 'DZ',
      objectType: 'PL',
      typeId: 1,
    }
    let queryUrl = item.likesFlag ? cancelType : operationType
    let msg = item.likesFlag ? '取消点赞成功' : '点赞成功'
    queryUrl(params).then((res) => {
      if (res.code == 0) {
        if (item.likesFlag) {
          item.likesFlag = false
          setLikesFlag(false)
          setLikesNum(likesNum - 1)
        } else {
          item.likesFlag = true
          setLikesFlag(true)
          setLikesNum(likesNum + 1)
        }
        Toast(msg)
      } else {
        Toast(res.msg)
      }
    })
  }

  return {
    likesFlag,
    likesNum,
    handleCommentLike,
  }
}

export default useCommentFabulousType
